<div mat-dialog-content>
  <p class="confirm-message" [id]="data.messageId">{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <ng-container *ngIf="data.kind === 'alert'; else confirmActions">
    <button type="button" class="btn btn-active" data-testid="alert-ok" [mat-dialog-close]="true">
      <ng-container *ngIf="data.okLabel; else defaultAlertOk">{{ data.okLabel }}</ng-container>
      <ng-template #defaultAlertOk><ng-container i18n>OK</ng-container></ng-template>
    </button>
  </ng-container>
  <ng-template #confirmActions>
    <button type="button" class="btn btn-default" data-testid="confirm-cancel" [mat-dialog-close]="false">
      <ng-container *ngIf="data.cancelLabel; else defaultCancel">{{ data.cancelLabel }}</ng-container>
      <ng-template #defaultCancel><ng-container i18n>Cancel</ng-container></ng-template>
    </button>
    <button type="button" class="btn btn-active" data-testid="confirm-ok" [mat-dialog-close]="true">
      <ng-container *ngIf="data.okLabel; else defaultOk">{{ data.okLabel }}</ng-container>
      <ng-template #defaultOk><ng-container i18n>OK</ng-container></ng-template>
    </button>
  </ng-template>
</div>
